/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';
import { UpdateMenuSubcategoryDto as DigiworkMaitreDPosDtoMenuSubcategoriesUpdateMenuSubcategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/update-menu-subcategory-dto';

export interface UpdateMenuSubcategory$Params {
  menuCategoryId: string;
  menuSubcategoryId: string;
      body?: DigiworkMaitreDPosDtoMenuSubcategoriesUpdateMenuSubcategoryDto
}

export function updateMenuSubcategory(http: HttpClient, rootUrl: string, params: UpdateMenuSubcategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>> {
  const rb = new RequestBuilder(rootUrl, updateMenuSubcategory.PATH, 'put');
  if (params) {
    rb.path('menuCategoryId', params.menuCategoryId, {});
    rb.path('menuSubcategoryId', params.menuSubcategoryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuSubcategoriesMenuSubcategoryDto>;
    })
  );
}

updateMenuSubcategory.PATH = '/api/menu-categories/{menuCategoryId}/menu-subcategories/{menuSubcategoryId}';
